module.exports = __webpack_public_path__ + "static/babyscan-c06857c4c43c99efe6bc4b14af6e72e2.jpeg";